import React from "react";
import Hero from "./sections/Hero";
import SummaryBar from "./sections/SummaryBar";
import Accordion from "./sections/Accordion";
import ChatLauncher from "./sections/ChatLauncher";
import TestimonialsMarquee from "./sections/TestimonialsMarquee";
import WelcomeChoice from "./sections/WelcomeChoice";
import "./styles.css";

/**
 * Portfolio home v3 — top bar + split hero + trusted strip + accordion.
 * Compact, tight vertical rhythm.
 */
export default function PortfolioHome() {
  return (
    <div className="rp-root rp-min-h-svh relative" style={{ background: "#EDE7D9" }}>
      <WelcomeChoice />
      <div className="rp-grain" />

      {/* Top bar */}
      <header
        className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 pt-4 md:pt-5 pb-2"
        data-testid="site-topbar"
      >
        <p
          className="uppercase"
          style={{
            fontFamily: "'Space Grotesk', system-ui, sans-serif",
            fontSize: "0.72rem",
            letterSpacing: "0.2em",
            color: "#8A7E6B",
            fontWeight: 400,
          }}
        >
          Roshan Raykar Portfolio
        </p>
      </header>

      <Hero />
      <SummaryBar />
      <Accordion />

      <TestimonialsMarquee />

      <footer className="py-8 px-6 md:px-12 border-t border-[#26201615] text-center">
        <p className="rp-display rp-italic text-sm text-[#8A7E6B]">
          © Roshan Raykar
        </p>
      </footer>

      <ChatLauncher />
    </div>
  );
}
